import { useMemo } from "react";

import {
  defaultPageNumber as pageNumber,
  defaultPageSize as pageSize,
} from "@/constants/pagination";
import useAuth from "@/contexts/auth-context";

import useGetAllCustomerSalesProducts from "./requests/customer-sales-product/use-get-all-customer-sales-product";

/**
 * Hook para verificar se todos os dados necessários estão carregados
 * Segue a mesma lógica do projeto Next.js
 * @returns Object com estado de carregamento da aplicação
 */
export const useAppReady = () => {
  const { isAuthenticated, isAuthReady } = useAuth();
  const { isLoading: isLoadingProducts } = useGetAllCustomerSalesProducts({
    pageNumber,
    pageSize,
  });

  const appState = useMemo(() => {
    // Se não está autenticado, app não está ready
    if (!isAuthenticated) {
      return {
        isReady: false,
        isLoadingUser: false,
        isLoadingProducts: false,
        reason: "not_authenticated",
      };
    }

    // Aguarda o auth estar pronto (carregar usuário) antes de considerar produtos
    if (!isAuthReady) {
      return {
        isReady: false,
        isLoadingUser: true,
        isLoadingProducts: false,
        reason: "loading_user",
      };
    }

    // Se ainda está carregando produtos, não está ready
    if (isLoadingProducts) {
      return {
        isReady: false,
        isLoadingUser: false,
        isLoadingProducts: true,
        reason: "loading_products",
      };
    }

    // Todos os dados carregados
    return {
      isReady: true,
      isLoadingUser: false,
      isLoadingProducts: false,
      reason: "ready",
    };
  }, [isAuthenticated, isAuthReady, isLoadingProducts]);

  return appState;
};

export default useAppReady;
